/* eslint-disable react/require-default-props */
/* eslint-disable react/no-unused-prop-types */

import React from 'react';
import { connect } from 'react-redux';

import CategoryItem from 'onboarding/services/CategoryItem';

export function ServicesScreen(props) {
  return (
    <div className="content">
      <div className="category-wrap">
        {props.categories &&
          props.categories.map((category, i) => {
            const expandedServices = [];
            // expand only the first service of the first category
            if (i === 0 && category.services.length > 0 && category.services[0].id && props.quickSetupLayoutPageTwo) {
              expandedServices.push(category.services[0].id);
            }

            return (
              <CategoryItem
                servicePriceChangeReset={() => {}}
                servicePriceHasChanged={false}
                removeAddService={() => {}}
                changeServicePosition={props.changeServicePosition}
                salonType={props.salonType}
                category={category}
                navigateToAddService={props.navigateToAddService}
                expandedServicesIDs={expandedServices}
                settingsSavedServicesIDs={[]}
                settingsErrorServicesIDs={[]}
                onAddNewService={props.onAddNewService}
                key={category.id}
                onEdit={props.onEdit}
                onDelete={props.onDelete}
                editCategoryClicked={() => props.editCategoryClicked(category)}
                quickSetupLayout={props.quickSetupLayoutPageOne || props.quickSetupLayoutPageTwo}
              />
            );
          })}
      </div>
    </div>
  );
}

const mapStateToProps = (state) => ({
  categories: state.onboarding.services.categories,
  salonType: state.currentSalon ? state.currentSalon.pricing_type : null,
});

export default connect(mapStateToProps)(ServicesScreen);
